import { graphql } from "@opensea/graphql"

export const CurrencyPriceFragment = graphql(`
  fragment CurrencyPrice on Currency {
    usdPrice
  }
`)
